//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//local imports 
import { DepartmentModel, RoomModel } from '@app/catalog';

@Component({
  selector: 'assign-room-to-department',
  standalone: false,
  templateUrl: './assign-room-to-department.component.html',
  styleUrl: './assign-room-to-department.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignRoomToDepartmentComponent {
  onCancelAssignment = output();

  rooms = input.required<RoomModel[]>();
  assignedRooms = input.required<RoomModel[]>();
  departments = input.required<DepartmentModel[]>();



  public applyAssignment() {

  }

  public cancelAssignment() {
    this.departments().forEach(item => item.isChecked.set(false));
    this.rooms().forEach(item => item.isChecked.set(false));
    this.onCancelAssignment.emit();
  }
}
